import FormItem from 'components/Form/FormItem'
import NcInputNumber from 'components/NcInputNumber/NcInputNumber';
import React, { FC, useEffect, useState } from 'react'
import { DateRangePicker, FocusedInputShape } from 'react-dates';
import { useTranslation } from 'react-i18next';
import ReactTextareaAutosize from 'react-textarea-autosize';
import ButtonPrimary from 'shared/Button/ButtonPrimary';
import moment, { Moment } from "moment";
import Input from 'shared/Input/Input';
import PhoneInputWithCountrySelect, { parsePhoneNumber } from 'react-phone-number-input';
import { authJsonPost, jsonPost, postNew } from 'functions/BaseAxios';
import { toast, ToastContainer } from 'react-toastify';
import Loader from 'react-loader-spinner';
import NcModal from 'shared/NcModal/NcModal';
import ButtonSecondary from 'shared/Button/ButtonSecondary';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootStore } from 'functions/redux/store';
import { checkLogin } from 'functions/redux/user/action';
import { CheckCircleIcon } from '@heroicons/react/solid';

export interface AuthorPageProps {
    className?: string;
}
const RequestGuide: FC<AuthorPageProps> = ({ className = "" }) => {
    const { user } = useSelector((state: RootStore) => state);
    const dispatch = useDispatch();
    const history = useHistory()
    const { t } = useTranslation();
    const [numberOfGuide, setnumberOfGuide] = React.useState('');
    const [smallLuggage, setSmallLuggage] = React.useState(0);
    const [underTwoYears, setUnderTwoYears] = React.useState(0);
    const [underTwelve, setUnderTwelve] = React.useState(0);
    const [bigLuggage, setBigLuggage] = React.useState(0);
    const [destination, setdestination] = React.useState('');
    const [name, setName] = useState(user.credential?.profile?.displayName ?? '');
    const [email, setEmail] = useState(user.credential?.email ?? '');
    const [adult, setAdult] = useState(1);
    const [focusedInput, setFocusedInput] = useState<null | FocusedInputShape>(null);
    const [dateRange, setDateRange] = useState<{ startDate: null | Moment, endDate: null | Moment }>({
        startDate: null,
        endDate: null,
    });
    const [value, setValue] = React.useState<any | null>(user.credential?.profile?.phoneNumber ?? '')
    const [phoneNumber, setPhoneNumber] = React.useState<any>('');
    const [countryNumber, setcountryNumber] = React.useState<any>("");
    const [codeNumber, setcodeNumber] = React.useState<any>("");
    const [loading, setLoading] = useState(false)
    const [confimationModal, setconfimationModal] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false);
    const [userId, setUserId] = useState(null);


    useEffect(() => {
        dispatch(checkLogin());
    }, [])

    useEffect(() => {
        setName(user.credential?.profile?.displayName ?? '')
        setEmail(user.credential?.email ?? '');
        setValue(user.credential?.profile?.phoneNumber ?? '')
        setPhoneNumber(user.credential?.profile?.phoneNumber ?? '')
        setUserId(user.credential?.id)
    }, [user])



    const setphoneFormat = (value: any) => {
        if (value !== undefined) {
            let parse = parsePhoneNumber(value);
            if (parse !== undefined) {
                setPhoneNumber(value);
                setcountryNumber(parse.country);
                setcodeNumber(parse.countryCallingCode);
            }

        } else {

            setcountryNumber('');
            setcodeNumber('');
        }
    }

    const checkData = () => {

        if (name == null || name === '') {
            toast(t('warning_insert_name'));
            return false;
        }

        if (email == null || email === '') {
            toast(t('warning_insert_email'));
            return false;
        }

        if (phoneNumber == null || phoneNumber === '' || phoneNumber === undefined) {
            toast(t('warning_insert_phone'));
            return false;
        }

        if (value == null || value === '' || value === undefined) {
            toast(t('warning_insert_phone'));
            return false;
        }

        if (dateRange.startDate == null) {
            toast(t('warning_insert_start_date'));
            return false;
        }

        if (dateRange.endDate == null) {
            toast(t('warning_insert_end_date'));
            return false;
        }



        if (destination == null || destination === '') {
            toast(t('warning_insert_destination'));
            return false;
        }

        setconfimationModal(true);
    }

    const sendRequest = async () => {


        let startDate = dateRange?.startDate?.format("YYYY-MM-DD");
        let endDate = dateRange?.endDate?.format("YYYY-MM-DD");
        setLoading(true);

        var data = {
            name,
            email,
            phoneNumber,
            destination,
            adult,
            underTwoYears,
            underTwelve,
            bigLuggage,
            smallLuggage,
            startDate,
            endDate,
            userId
        }

        var send = await jsonPost(
            data,
            'api/request-guide',
        )

        if (send.code === 200) {
            setDateRange({
                startDate: null,
                endDate: null
            })
            setName('');
            setEmail('')
            setPhoneNumber('');
            setValue('');
            setcodeNumber('');
            setcountryNumber('');
            setdestination('');
            setnumberOfGuide('');
            setAdult(0);
            setUnderTwelve(0);
            setUnderTwoYears(0);
            setBigLuggage(0);
            setSmallLuggage(0);
            // window.location.reload();
            setIsSuccess(true);
            toast(t('succes_request_guide'));

        } else if (send.code !== 200 && send.payload) {
            toast(send.payload.message);

        } else {
            toast(t('error_system'));

        }

        setLoading(false);

    }



    return (
        <div className='flex justify-center mb-10 px-4'>
            <ToastContainer position="bottom-right" />
            <NcModal
                isOpenProp={confimationModal}
                renderTrigger={() => { return (<div></div>); }}
                onCloseModal={() => {
                    setconfimationModal(false)
                    if (isSuccess) {
                        setIsSuccess(false);
                        window.location.reload();
                    }
                }}
                // contentExtraClass="w-1/4"
                modalTitle={t('confirmation')}
                renderContent={() => {
                    return (
                        <div className="max-w-md">
                            {isSuccess ? (
                                <div className='flex justify-center flex-col items-center'>
                                    <h4 className='font-semibold text-center'>{t('succes_request_guide')}</h4>
                                    <h4 className='font-semibold text-center'>{t('succes_request_guide_desc')}</h4>
                                    <CheckCircleIcon className='w-44 h-44' style={{ color: '#FAB005' }} />
                                    <ButtonSecondary onClick={() => {
                                        setconfimationModal(false);
                                        setIsSuccess(false);
                                        window.location.reload();
                                    }}>{t('ok')}</ButtonSecondary>
                                </div>
                            ) : (
                                <div>
                                    <h4 className='mb-4'>{t('please_check_your_data')}</h4>
                                    <div className='flex justify-between gap-2'>
                                        <ButtonSecondary onClick={() => setconfimationModal(false)}>{t('check')}</ButtonSecondary>
                                        <ButtonPrimary onClick={sendRequest}>
                                            {loading ? <Loader
                                                type="Circles"
                                                color="white"
                                                height={25}
                                                width={25}
                                            /> : t('send')}</ButtonPrimary>
                                    </div>
                                </div>
                            )}

                        </div>
                    );
                }}
            />

            <div className='w-full md:w-1/2  flex justify-center' style={{ minHeight: '50vh' }}>
                <div className='listingSection__wrap'>
                    <>
                        <div>
                            <h2 className='text-2xl font-semibold'>{t('request_guide')}</h2>
                            <h6 className='text-neutral-500 dark:text-neutral-400 text-sm'>{t('request_guide_desc')}</h6>
                        </div>
                        <div className='w-full border-b border-neutral-200 dark:border-neutral-700 mt-4'></div>

                        <div className="md:flex flex-row justify-between  w-full">
                            <div className='flex flex-col'>
                                <span className="text-md font-semibold">
                                    {t('name')}<span className='text-red-500'>*</span>
                                </span>
                            </div>
                            <div className='flex items-center'>
                                {user?.credential?.profile?.displayName ? <span className='font-semibold'>{name}</span> : (
                                    <Input placeholder={t('name')} value={name} onChange={(e) => setName(e.target.value)} />
                                )}
                            </div>
                        </div>
                        <div className="md:flex flex-row justify-between  w-full">
                            <div className='flex flex-col'>
                                <span className="text-md font-semibold">
                                    Email<span className='text-red-500'>*</span>
                                </span>
                            </div>
                            <div className=''>
                                {user?.credential?.email ? <span className='font-semibold'>{email}</span> : (
                                    <Input className='w-full' type='email' placeholder='Email' value={email} onChange={(e) => setEmail(e.target.value)} />

                                )}
                            </div>
                        </div>
                        <div className="md:flex flex-row justify-between  w-full">
                            <div className='flex flex-col'>
                                <span className="text-md font-semibold">
                                    {t('phone_number')}<span className='text-red-500'>*</span>
                                </span>
                            </div>
                            <div>
                                {user?.credential?.profile?.phoneNumber ? <span className='font-semibold'>{value}</span> : (
                                    // <Input placeholder={t('name')} value={name} onChange={(e) => setName(e.target.value)} />
                                    <PhoneInputWithCountrySelect
                                        international
                                        // defaultCountry="ID"
                                        // onCountryChange={(con) => console.log(con)}
                                        value={value}
                                        onChange={phone => {

                                            let ph = phone;
                                            setValue(phone);
                                            // console.log(phone);
                                            setphoneFormat(phone);
                                            // if (value) {
                                            //   console.log(parsePhoneNumber(value));
                                            // }
                                        }}
                                    />
                                )}

                            </div>
                        </div>
                        <div className="relative flex-shrink-0 flex z-10 [ lg:nc-flex-2 ] ">
                            <div className="absolute right-0 bottom-0">
                                <DateRangePicker
                                    startDate={dateRange.startDate}
                                    endDate={dateRange.endDate}
                                    focusedInput={focusedInput}
                                    numberOfMonths={1}
                                    onDatesChange={(date) => {
                                        setDateRange(date);
                                        setFocusedInput(null);
                                    }}
                                    onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
                                    startDateId={"nc-hero-stay-startDateId"}
                                    endDateId={"nc-hero-stay-endDateId"}
                                    orientation={"horizontal"}
                                    showClearDates
                                    noBorder
                                    keepOpenOnDateSelect
                                    hideKeyboardShortcutsPanel
                                />
                            </div>
                            <div className="md:flex justify-between lg:flex-row lg:items-center w-full flex-shrink-0 relative">
                                <div className='flex flex-col'>
                                    <span className="text-md font-semibold">
                                        {t('destination_date')}<span className='text-red-500'>*</span>
                                    </span>
                                </div>
                                <div className='md:w-52'>
                                    <Input className='' onClick={() => setFocusedInput('startDate')} value={(dateRange.startDate ? dateRange.startDate.format("DD MMM YYYY") : "") + ' - ' + (dateRange.endDate ? dateRange.endDate.format("DD MMM YYYY") : "")} readOnly={true} />
                                </div>
                            </div>
                        </div>

                        <div className="">
                            <div className=" mb-4">
                                <span className="text-md font-semibold">
                                    {t('number_guest')}
                                </span>
                                <div className="flex flex-row justify-between mt-2 mb-2 w-full">
                                    <span className="flex-1 ">
                                        {t('adult')}
                                    </span>
                                    <NcInputNumber
                                        className="w-min"
                                        min={1}
                                        defaultValue={1}
                                        onChange={(value) => {
                                            setAdult(value)
                                        }}
                                    />
                                </div>
                                <div className="flex flex-row justify-between mt-2 mb-2 w-full">
                                    <span className="flex-1 ">
                                        {t('under_two_year')}
                                    </span>
                                    <NcInputNumber
                                        className="w-min"
                                        defaultValue={0}
                                        onChange={(value) => {
                                            setUnderTwoYears(value)
                                        }}
                                    />
                                </div>
                                <div className="flex flex-row justify-between mb-2 w-full">
                                    <span className="flex-1">
                                        {t('under_twelve')}
                                    </span>
                                    <NcInputNumber
                                        className="w-min"
                                        defaultValue={0}
                                        onChange={(value) => {
                                            setUnderTwelve(value)
                                        }}
                                    />
                                </div>
                            </div>
                            <span className="text-md font-semibold">
                                {t('numberLuggages')}
                            </span>
                            <div className="flex flex-row justify-between mt-2 mb-2 w-full">
                                <span className="flex-1">
                                    {t('big_luggage')}
                                </span>
                                <NcInputNumber
                                    className="w-min"
                                    defaultValue={0}
                                    onChange={(value) => {
                                        setBigLuggage(value)
                                    }}
                                />
                            </div>
                            <div className="flex flex-row justify-between mb-2 w-full">
                                <span className="flex-1">
                                    {t('small_luggage')}
                                </span>
                                <NcInputNumber
                                    className="w-min"
                                    defaultValue={0}
                                    onChange={(value) => {
                                        setSmallLuggage(value)
                                    }}
                                />
                            </div>
                        </div>

                        <div>
                            <div className='flex flex-col mb-1'>
                                <span className="text-md font-semibold">
                                    {t('destinations')}<span className='text-red-500'>*</span>
                                </span>
                            </div>
                            <ReactTextareaAutosize onChange={(e) => {
                                setdestination(e.target.value)
                            }} placeholder='cnt. Zürich, Appenzell, Lausanne' minRows={3} className='block w-full text-sm rounded-2xl border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 mb-2' />

                        </div>
                        <div className='flex justify-center'>
                            <ButtonPrimary onClick={() => checkData()}>
                                {loading ? <Loader
                                    type="Circles"
                                    color="white"
                                    height={25}
                                    width={25}
                                /> : t('send_request')}</ButtonPrimary>
                        </div>
                    </>
                </div>
            </div>
        </div>
    )
}

export default RequestGuide